import axios from 'axios'
import { API_ENDPOINT } from '../../../config'

const getDefaultState = () => {
    return {
        loading: false,
        roles: [],
        filter: {
            column: "",
            value: ""
        },
        showDelete: false,
        roleToDelete: null,
        selectedIndex: -1,
        currentPage: 1,
        pageSize: 10,
        total: 0
    }
}

const loadRoles = instance => {
    instance.setState({ ...instance.state, loading: true })
    let criteria = {}
    if (instance.state.filter.column.length > 0 && instance.state.filter.value.length > 0) {
        criteria = {
            [instance.state.filter.column]: instance.state.filter.value
        }
    }
    axios({
        method: 'post',
        url: API_ENDPOINT + "/user/roles",
        headers : {
            "Authorization": instance.props.auth.authorization
        },
        data: {
            offset: (instance.state.currentPage - 1) * instance.state.pageSize,
            limit: instance.state.pageSize,
            criteria: criteria
        }
    }).then(response => handleLoadRolesResponse(instance, response))
    .catch(error => alert(error))
}

const handleLoadRolesResponse = (instance, response) => {
    switch(response.data.status){
        case 200:
            instance.setState({
                ...instance.state,
                loading: false,
                selectedIndex: -1,
                roles: response.data.data.roles,
                total: response.data.data.size
            })
            break;
        case 403:
            instance.props.history.push('/auth/login')
            break;
        default:
            alert(response.data.message)
    }
}

const Service = instance => {
    return {
        loadRoles: () => loadRoles(instance),
        getDefaultState: () => getDefaultState(instance)
    }
}

export default Service